import { isNotNil } from '@flowio/is';
import { PaymentRequestError, RequestPaymentParameters } from '../types';
import { toCamelCaseKeysNested } from './mapKeysNested';

type HandlePaymentRequestFailure = {
  requestOptions: RequestPaymentParameters;
  error?: PaymentRequestError;
  paymentFailure?: io.flow.v0.models.PaymentFailure;
};

export default function handlePaymentRequestFailure(
  params: HandlePaymentRequestFailure,
): void {
  if (isNotNil(params.requestOptions.onFailure)) {
    if (isNotNil(params.error)) {
      params.requestOptions.onFailure({ type: 'request_payment_error', error: params.error });
    } else if (isNotNil(params.paymentFailure)) {
      const convertedRequest = toCamelCaseKeysNested<
      io.flow.v0.models.PaymentFailure
      >(params.paymentFailure);

      params.requestOptions.onFailure({ type: 'request_payment_failure', failure: convertedRequest });
    }
  }
}
